import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { container, fadeUp } from '@/constants/motion';
export const HowItWorks = () => {
    const { t } = useTranslation('marketing');
    const howItWorksSteps = React.useMemo(() => [
        {
            label: t('landing.howItWorks.steps.step1.label'),
            body: t('landing.howItWorks.steps.step1.body'),
            title: t('landing.howItWorks.steps.step1.title'),
        },
        {
            label: t('landing.howItWorks.steps.step2.label'),
            body: t('landing.howItWorks.steps.step2.body'),
            title: t('landing.howItWorks.steps.step2.title'),
        },
        {
            label: t('landing.howItWorks.steps.step3.label'),
            body: t('landing.howItWorks.steps.step3.body'),
            title: t('landing.howItWorks.steps.step3.title'),
        },
        {
            label: t('landing.howItWorks.steps.step4.label'),
            body: t('landing.howItWorks.steps.step4.body'),
            title: t('landing.howItWorks.steps.step4.title'),
        },
    ], [t]);
    return (<motion.div className="border-b bg-muted/30" initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-80px' }} variants={container}>
            <div className="mx-auto max-w-5xl px-4 py-16 md:py-20">
                <motion.p variants={fadeUp} className="text-center text-xs font-semibold uppercase tracking-widest text-primary mb-3">
                    How it works
                </motion.p>
                <motion.h2 className="text-center text-3xl font-bold md:text-4xl" variants={fadeUp}>
                    {t('landing.howItWorks.title')}
                </motion.h2>
                <motion.p className="mt-3 text-center text-sm text-muted-foreground md:text-base max-w-xl mx-auto leading-relaxed" variants={fadeUp}>
                    {t('landing.howItWorks.subtitle')}
                </motion.p>

                <div className="mt-12 grid gap-6 md:grid-cols-4">
                    {howItWorksSteps.map((step, index) => (<motion.div key={step.label} className="relative flex flex-col gap-4 rounded-2xl border bg-card p-5 overflow-hidden" variants={fadeUp} transition={{ duration: 0.45, delay: 0.1 + index * 0.08 }} whileHover={{ y: -4, boxShadow: '0 12px 30px rgba(0,0,0,0.08)' }}>
                            {/* Large background number */}
                            <span className="pointer-events-none absolute -bottom-3 -right-1 text-8xl font-black text-muted-foreground/8 leading-none select-none">
                                {index + 1}
                            </span>

                            <div className="relative z-10 inline-flex h-8 w-8 items-center justify-center rounded-full bg-primary text-xs font-bold text-white shrink-0">
                                {step.label}
                            </div>

                            <div className="relative z-10">
                                <h3 className="text-sm font-semibold">{step.title}</h3>
                                <p className="mt-1.5 text-xs text-muted-foreground leading-relaxed">{step.body}</p>
                            </div>
                        </motion.div>))}
                </div>
            </div>
        </motion.div>);
};
HowItWorks.displayName = 'HowItWorks';
